var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './NotificationsCenterView.html';
import * as styles from './notificationsCenter.module.scss';
import { BlipService } from 'modules/messaginghub/BlipService';
import { addUsersMessageId } from 'modules/account/AccountService2';
import { blipDomain } from 'app.constants';
const ACCEPTED_TYPES = ['text/plain', 'application/vnd.lime.web-link+json'];
let NotificationsCenterComponent = class NotificationsCenterComponent {
    static $inject = ['BlipService'];
    constructor(BlipService) {
        this.BlipService = BlipService;
        this.notificationsCount = 0;
        this.messageReceiverCleanup = null;
        this.styles = styles;
    }
    async $onInit() {
        try {
            const setupNotificationInitializer = async () => {
                await this.getNotifications();
                // Store the cleanup function returned by addMessageReceiver
                this.messageReceiverCleanup = this.BlipService.addMessageReceiver(this.onReceiveMessage.bind(this), m => m.from.startsWith('notifications@msging.net') && m.id != addUsersMessageId);
            }; /**
             * Avoid code blocks execution using "then" syntax
             */
            this.BlipService
                .waitForInitialization()
                .then(setupNotificationInitializer);
        }
        catch (e) {
            console.error(e);
            this.hasNotifications = false;
        }
    }
    $onDestroy() {
        clearInterval(this.getNotificationsInterval);
        // Clean up message receiver if it was registered
        if (this.messageReceiverCleanup && typeof this.messageReceiverCleanup === 'function') {
            this.messageReceiverCleanup();
        }
    }
    increaseNotificationsCount() {
        this.notificationsCount++;
    }
    resetNotificationsCount() {
        this.notificationsCount = 0;
    }
    setNotificationsCount(count) {
        this.notificationsCount = count;
    }
    /**
     * Add new notification and remove last
     * @param message - Notification message
     */
    onReceiveMessage(message) {
        if (!ACCEPTED_TYPES.includes(message.type) || this.notifications.find(n => message.id == n.id)) {
            return;
        }
        const addReceivedStatus = n => ({ ...n, status: 'received' });
        this.notifications = [addReceivedStatus(message), ...this.notifications.removeLast()];
        this.hasNotifications = true;
        this.increaseNotificationsCount();
    }
    /**
     * Switch between 5 or 10 items on notifications list
     */
    toggleExpandItems($e) {
        $e.stopPropagation();
        if (this.isExpanded) {
            this.getNotifications(5);
            this.isExpanded = false;
        }
        else {
            this.getNotifications(10);
            this.isExpanded = true;
        }
    }
    /**
     * Get threads history
     * @param take items to take from threads
     */
    async getNotifications(take = 5) {
        const { items: notifications } = await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@threads.${blipDomain}`,
            uri: `/threads/notifications%40msging.net?direction=desc&$take=${take}`,
        });
        const uniqueNotificationsById = array => {
            let tempArray = [];
            array.forEach(n => {
                if (tempArray.length == 0
                    || !tempArray.find(({ id }) => id == n.id)) {
                    tempArray = tempArray.concat(n);
                }
            });
            return tempArray;
        };
        this.notifications =
            uniqueNotificationsById(notifications)
                .filter(n => ACCEPTED_TYPES.includes(n.type) && n.id != addUsersMessageId);
        const newNotifications = this.notifications.filter(n => n.direction === 'received' && (!n.status || n.status !== 'consumed'));
        if (newNotifications.length > 0) {
            this.hasNotifications = true;
            this.setNotificationsCount(newNotifications.length);
        }
    }
    /**
     * Send consumed notification to all notification items that have status 'received'
     */
    async onOpenNotifications() {
        try {
            if (!this.notifications) {
                return;
            }
            const thenables = this.notifications
                .filter(n => n.status === 'received' || !n.status)
                .reduce((ns, n) => ns.concat(this.BlipService.sendNotification({
                id: n.id,
                to: 'notifications@msging.net',
                event: 'consumed',
            })), []);
            if (thenables.length > 0) {
                await Promise.all(thenables);
                this.hasNotifications = false;
                this.resetNotificationsCount();
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async setOpenMenu() {
        try {
            if (!this.notifications) {
                const e = document.getElementById('menuNotification');
                e.open = !e.open;
                return;
            }
            const thenables = this.notifications
                .filter(n => n.status === 'received' || !n.status)
                .reduce((ns, n) => ns.concat(this.BlipService.sendNotification({
                id: n.id,
                to: 'notifications@msging.net',
                event: 'consumed',
            })), []);
            if (thenables.length > 0) {
                await Promise.all(thenables);
                this.hasNotifications = false;
                this.resetNotificationsCount();
            }
            const e = document.getElementById('menuNotification');
            e.open = !e.open;
            return;
        }
        catch (e) {
            console.error(e);
        }
    }
    redirectNotification(uri) {
        window.location.href = uri;
        return;
    }
};
NotificationsCenterComponent.$inject = ['BlipService'];
NotificationsCenterComponent = __decorate([
    Component({
        template,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BlipService !== "undefined" && BlipService) === "function" ? _a : Object])
], NotificationsCenterComponent);
export { NotificationsCenterComponent };
